import axios from "axios";
import _ from "lodash";
import constants from "@/config/constants";
function initialState() {
    return {
        item: {
            event_id                : null,
            header_banner_video     : null,
            header_banner_image     : null,
            is_header_banner_video  : true,
            show_social_header      : true,
            show_social_footer      : true,
            show_partners_footer    : true,
            show_newsletter_footer    : true,
            footer_color            : "#000000",
            button_color            : "#FF0000",
            button_text_color       : "#FFFFFF",
            landing_page_theme_color : "#123456",
            mid_section:[
                {
                    label : "CountDown Timer",
                    key:"countdown_timer",
                    is_show:true,
                    sort_order: 1,
             
                },
                {
                    label : "Welcome Note",
                    key:"welcome_note",
                    is_show:true,
                    sort_order: 2,
                    welcome_note_text: null,
                    welcome_note_image:null
                },
                {
                    label : "Speaker Statistics",
                    key:"speaker_statistics",
                    is_show:true,
                    sort_order: 3,
             
                },
                {
                    label : "Schedule",
                    key:"schedule",
                    is_show:true,
                    sort_order: 4,
             
                },
                {
                    label : "HighLights",
                    key:"highlights",
                    is_show:true,
                    sort_order: 5,
             
                },
                {
                    label : "Event Gallery",
                    key:"gallery",
                    is_show:true,
                    sort_order: 6,
             
                },
                {
                    label : "Sponsors",
                    key:"sponsors",
                    is_show:true,
                    sort_order: 7,
             
                },
                {
                    label : "Exhibitors",
                    key:"exhbitors",
                    is_show:true,
                    sort_order:8,
             
                },
                {
                    label : "FAQ",
                    key:"faq",
                    is_show:true,
                    sort_order:9,
             
                }
            
        
        ]


        },
      
        loading: false,
    }
}

const getters = {
    item: state => state.item,
    loading: state => state.loading,
    
}

const actions = {
    storeData({ commit, state, dispatch }) {
        commit('setLoading', true)
       
    },
    async updateData({ commit, state }) {
        commit('setLoading', true)

        let params = _.cloneDeep(state.item);
        // params = _.omitBy(params, _.isNil);

        delete params._id;
       // delete params.event_id;
       // delete params.event_id;
        delete params.createdAt;
        delete params.updatedAt;
        delete params.__v;
       


        if (_.has(state.item.header_banner_image, 'key')) {
            let imgPath = _.replace(state.item.header_banner_image.key, '/draft', '');
            params.header_banner_image = {
                key: imgPath,
                old_key: (!_.isNull(state.item.header_banner_image.key) && !_.isNull(state.item.header_banner_image.key.match(/\/draft\//g))) ? state.item.header_banner_image.key : null,
                size: params.header_banner_image.size,
                extension: params.header_banner_image.extension,
                uploadedBy: params.header_banner_image.uploadedBy,
                uploadedAt: params.header_banner_image.uploadedAt,
            }
        }

        if (_.has(state.item.header_banner_video, 'key')) {
            let imgPath = _.replace(state.item.header_banner_video.key, '/draft', '');
            params.header_banner_video = {
                key: imgPath,
                old_key: (!_.isNull(state.item.header_banner_video.key) && !_.isNull(state.item.header_banner_video.key.match(/\/draft\//g))) ? state.item.header_banner_video.key : null,
                size: params.header_banner_video.size,
                extension: params.header_banner_video.extension,
                uploadedBy: params.header_banner_video.uploadedBy,
                uploadedAt: params.header_banner_video.uploadedAt,
            }
        }
            const welcomeNoteSection = params.mid_section.find(s => s.key === 'welcome_note');

            if (_.has(welcomeNoteSection?.welcome_note_image, 'key')) {
            const imgPath = _.replace(welcomeNoteSection.welcome_note_image.key, '/draft', '');

            welcomeNoteSection.welcome_note_image = {
                key: imgPath,
                old_key: (
                !_.isNull(welcomeNoteSection.welcome_note_image.key) &&
                !_.isNull(welcomeNoteSection.welcome_note_image.key.match(/\/draft\//g))
                )
                ? welcomeNoteSection.welcome_note_image.key
                : null,
                size: welcomeNoteSection.welcome_note_image.size,
                extension: welcomeNoteSection.welcome_note_image.extension,
                uploadedBy: welcomeNoteSection.welcome_note_image.uploadedBy,
                uploadedAt: welcomeNoteSection.welcome_note_image.uploadedAt,
            };
            }


            return axios.patch(constants.API_URL + '/api/landing-page/event-id/' + state.item.event_id + '/' , params)
    
            .then(response => {
                console.log("response.data.data===>",response.data.data);
                commit('setItem', response.data.data)
                return response;
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    fetchData({ commit, dispatch }, params) {
        commit('setLoading', true)
        commit('setEvent', params.event_id)
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
        return axios.get(constants.API_URL + `/api/landing-page/event-id/${params.event_id}/`,{headers: headers})
            .then(response => {
                
                commit('setItem', response.data.data)
                return response
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },

    setIsShowFooterNewsLetter({commit},value){
        commit('setIsShowFooterNewsLetter',value);
    },
    setIsShowFooterPartner({commit},value){
        commit('setIsShowFooterPartner',value);
    },
    setIsShowSocialFooter({commit},value){
        commit('setIsShowSocialFooter',value);
    },
    setIsShowSocialHeader({commit},value){
        commit('setIsShowSocialHeader',value);
    },
    setIsHeaderBannerVideo({commit},value){
        commit('setIsHeaderBannerVideo',value);
    },
   
    fetchEventsAll({ commit }, event_id) {
        commit('setEvent', event_id)
    },
   
    setEvent({ commit }, value) {
        commit('setEvent', value)
    },
    
    resetState({ commit }) {
        commit('resetState')
    },
    setBannerLong({ commit }, value) {
        commit('setBannerLong', value)
    },
    removeBannerLong({ commit }, value) {
        commit('removeBannerLong', value)
    },
    setBannerSmall({ commit }, value) {
        commit('setBannerSmall', value)
    },
    removeBannerSmall({ commit }, value) {
        commit('removeBannerSmall', value)
    },
    setBannerMedium({ commit }, value) {
        commit('setBannerMedium', value)
    },
    removeBannerMedium({ commit }, value) {
        commit('removeBannerMedium', value)
    },
    setHeaderImage({ commit }, value) {
        commit('setHeaderImage', value)
    },
    setHeaderVideo({ commit }, value) {
        commit('setHeaderVideo', value)
    },
    setMidSection({ commit }, value) {
        commit('setMidSection', value);
    },
    

    
    toggleMidSectionVisibility({ commit }, key) {
        commit('toggleMidSectionVisibility', key);
    },
    
    addMidSection({ commit }, newSection) {
        commit('addMidSection', newSection);
    },
    
    removeMidSectionByKey({ commit }, key) {
        commit('removeMidSectionByKey', key);
    },
    updateMidSectionByKey({ commit }, payload) {
        commit('updateMidSectionByKey', payload);
    },
    setWelcomeImage({commit},payload){
        commit('setWelcomeImage', payload);
    },
    setRegistrationText({commit},value){
        commit('setRegistrationText',value)
    },
    setConferenceText({commit}, value){
        commit('setConferenceText',value)
    },
    setEventGalleryText({commit}, value){
        commit('setEventGalleryText',value)
    },
    setSponsorText({commit}, value){
        commit('setSponsorText',value)
    },
    setKeynoteSpeakerText({commit}, value){
        commit('setKeynoteSpeakerText',value)
    },
    setExhibitorText({commit}, value){
        commit('setExhibitorText',value)
    },
    setOnDemandText({commit}, value){
        commit('setOnDemandText',value)
    },
    setButtonColor({commit}, value){
        commit('setButtonColor', value)
    },
    setFooterColor({commit}, value){
        commit('setFooterColor', value)
    },
    setButtonTextColor({commit}, value){
        commit('setButtonTextColor', value)
    },
    setLandingPageThemeColor({commit}, value){
        commit('setLandingPageThemeColor', value)
    },
    setFooterText({commit}, value){
        commit('setFooterText', value)
    }

}

const mutations = {
    setFooterText(state, value){
        state.item.footer_text = value
    },
    setLandingPageThemeColor(state, value){
        state.item.landing_page_theme_color = value
    },
    setButtonColor(state, value){
        state.item.button_color = value
    },
    setFooterColor(state, value){
        state.item.footer_color = value
    },
    setButtonTextColor(state, value){
        state.item.button_text_color = value
    },
    setWelcomeImage(state,value){
       // state.item.mid_section.
       const section = state.item.mid_section.find(item => item.key === "welcome_note");
       if (section) {
        Object.assign(section, {"welcome_note_image":value});
    }
    },
    updateMidSectionByKey(state, { key, updates }) {
        const section = state.item.mid_section.find(item => item.key === key);
        console.log("section",section,"key",key,"updates", updates);
        if (section) {
            Object.assign(section, updates);
        }
    },
    setMidSection(state, value) {
        state.item.mid_section = value;
    },
    
    
    
    toggleMidSectionVisibility(state, key) {
        const section = state.item.mid_section.find(item => item.key === key);
        if (section) {
            section.is_show = !section.is_show;
        }
    },
    
    addMidSection(state, newSection) {
        state.item.mid_section.push(newSection);
    },
    
    removeMidSectionByKey(state, key) {
        const index = state.item.mid_section.findIndex(item => item.key === key);
        if (index !== -1) {
            state.item.mid_section.splice(index, 1);
        }
    },

    setIsShowFooterNewsLetter(state,value){
        state.item.show_newsletter_footer = value
    },
    setIsShowFooterPartner(state,value){
        state.item.show_partners_footer = value
    },
    setIsShowSocialFooter(state,value){
        state.item.show_social_footer = value
    },
    setIsShowSocialHeader(state, value){
        state.item.show_social_header = value
    },
    setIsHeaderBannerVideo(state,value){
        state.item.is_header_banner_video = value
    },
    setHeaderVideo(state,value){
        state.item.header_banner_video = value;
    },
    setHeaderImage(state,value){
        state.item.header_banner_image = value;
    },
    setEventType(state, value) {
        state.event_type = value
    },
    setItem(state, item) {
        state.item = item
    },
    setScreenDesc1(state, value) {
        state.item.screen_1_description = value
    },
    setScreenDesc2(state, value) {
        state.item.screen_2_description = value
    },
    setSkybox_is_custom(state, value) {
        state.item.skybox_is_custom = value
        
    },
    setEnvironment_is_custom(state, value) {
        state.item.environment_is_custom = value
        
    },
    setEvent(state, value) {
        state.item.event_id = value
    },
    setSkybox(state, value) {
        state.item.skybox = value
    },
    setEnvironment(state, value) {
        state.item.environment = value
    },
    setAuditorium_live(state, value) {
        state.item.auditorium_live = value
    },
    setExhibitionPicture(state, value) {
        state.item.exhibition_picture = value
    },
 
    setAuditorium_pre_recorded(state, value) {
        state.item.auditorium_pre_recorded = value
        
    },
    setAuditorium_panel_discussion(state, value) {
        state.item.auditorium_panel_discussion = value
        
    },
    setExhibition_area(state, value) {
        state.item.exhibition_area = value
        
    },
    setVirtual_training(state, value) {
        state.item.virtual_training = value
        
    },
    setRoundtable(state, value) {
        state.item.roundtable = value
        
    },
    setVirtual_meeting(state, value) {
        state.item.virtual_meeting = value
        
    },
    setScrollingText(state, value) {
        state.item.scrolling_text = value

    },
    setAuditorium_live_label(state, value) {
        state.item.auditorium_live_label = value

    },
    setAuditorium_pre_recorded_label(state, value) {
        state.item.auditorium_pre_recorded_label = value

    },
    setAuditorium_panel_discussion_label(state, value) {
        state.item.auditorium_panel_discussion_label = value

    },
    setExhibition_area_label(state, value) {
        state.item.exhibition_area_label = value

    },
    setVirtual_training_label(state, value) {
        state.item.virtual_training_label = value

    },
    setRoundtable_label(state, value) {
        state.item.roundtable_label = value

    },
    setVirtual_meeting_label(state, value) {
        state.item.virtual_meeting_label = value

    },
    setExhibition_video(state, value) {
        state.item.exhibition_video = value
       
    },
    setScreen_video1(state, value) {
        state.item.screen_video1 = value
       
    },
    setScreen_video2(state, value) {
        state.item.screen_video2 = value
        
    },
    setScreen_video3(state, value) {
        state.item.screen_video3 = value
       
    },
    setScreen_video4(state, value) {
        state.item.screen_video4 = value
        
    },
    setScreen_video5(state, value) {
        state.item.screen_video5 = value
        
    },
    setScreen_video6(state, value) {
        state.item.screen_video6 = value
       
    },
    setScreen_video7(state, value) {
        state.item.screen_video7 = value
        
    },
    setExhibition_document(state, value) {
        state.item.exhibition_document = value
       
    },
    setScreen_document1(state, value) {
        state.item.screen_document1 = value
        
    },
    setScreen_document2(state, value) {
        state.item.screen_document2 = value
       
    },
    setScreen_document3(state, value) {
        state.item.screen_document3 = value
       
    },
    setScreen_document4(state, value) {
        state.item.screen_document4 = value
       
    },
    setScreen_document5(state, value) {
        state.item.screen_document5 = value
        if (value == '') {
            state.item.screen_document5_delete = 1
        } else {
            state.item.screen_document5_delete = 0
        }
    },
    setScreen_document6(state, value) {
        state.item.screen_document6 = value
        if (value == '') {
            state.item.screen_document6_delete = 1
        } else {
            state.item.screen_document6_delete = 0
        }
    },
    setScreen_document7(state, value) {
        state.item.screen_document7 = value
        if (value == '') {
            state.item.screen_document7_delete = 1
        } else {
            state.item.screen_document7_delete = 0
        }
    },
    setLogo_standee(state, value) {
        state.item.logo_standee = value
        
    },
    setBackgroundPicture(state, value) {
        state.item.background_picture = value
        
    },
    setBackgroundColor(state, value) {
        state.item.background_color_top = value
    },
    setBackgroundColorBottom(state, value) {
        state.item.background_color_bottom = value
    },
    setMaxCountBooth(state, value) {
        state.item.max_count_booth = value
    },
    setIs_picture(state, value) {
        state.item.is_picture = value
    },
    setSkyboxPicture(state,value){
        state.item.skybox_picture = value;
    },
    setEnvironmentPicture(state, value){
        state.item.environment_picture = value;
    },
    setFlags(state,value){
        state.item.flag.push(value);
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    removeFlags(state, value) {
        const index = state.item.flag.findIndex(i => i.key === value);
        if (index !== -1) {
            state.item.flag.splice(index, 1);
        }
       /* for (let i of state.item.flag) {
            if (i.key == value) {
                state.item.flag.splice(i.key, 1);
            }
        }*/
    },
    setBannerLong(state,value){
        state.item.banner_long.push(value);
    },
    removeBannerLong(state, value) {
        const index = state.item.banner_long.findIndex(i => i.key === value);
        if (index !== -1) {
            state.item.banner_long.splice(index, 1);
        }
        /*for (let i of state.item.banner_long) {
            if (i.key == value) {
                state.item.banner_long.splice(i.key, 1);
            }
        }*/
    },
    setBannerSmall(state,value){
        state.item.banner_small.push(value);
    },
    removeBannerSmall(state, value) {
        const index = state.item.banner_small.findIndex(i => i.key === value);
        if (index !== -1) {
            state.item.banner_small.splice(index, 1);
        }
        /*for (let i of state.item.banner_small) {
            if (i.key == value) {
                state.item.banner_small.splice(i.key, 1);
            }
        }*/
    },
    setBannerMedium(state,value){
        state.item.banner_medium.push(value);
    },
    removeBannerMedium(state, value) {
        const index = state.item.banner_medium.findIndex(i => i.key === value);
        if (index !== -1) {
            state.item.banner_medium.splice(index, 1);
        }
       /* for (let i of state.item.banner_small) {
            if (i.key == value) {
                state.item.banner_medium.splice(i.key, 1);
            }
        }*/
    },
    setRegistrationText(state,value){
        state.item.registeration_text = value
    },
    setConferenceText(state, value){
        state.item.conference_text = value
    },
    setEventGalleryText(state, value){
        state.item.event_galary_text = value
    },
    setSponsorText(state, value){
       state.item.sponsor_text = value
    },
    setKeynoteSpeakerText(state, value){
        state.item.keynote_speaker_text = value
    },
    setExhibitorText(state, value){
        state.item.event_exhibitors_text = value
    },
    setOnDemandText(state, value){
       state.item.on_demand_text = value
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
